<template>
  <div class="main_body">
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <div class="container-fluid">

    <div class="text-center mt-0 pb-4 d-none">
      <h2>Dashboard</h2>
    </div>

<!--revenue -->

    <div class="mb-3">
      <h4 class="revenue-header1 fw-bolder">Last 7 days revenue</h4>
      <div class="row gy-4 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
        <div class="col stretch-card">
          <div class="card bg-gradient-success5 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100 cp" data-bs-toggle="modal" data-bs-target="#bKashRecurring">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    bKash Recurring
                  </p>
                  <h5 v-if="last7daysrevenueData.bKashRecurring!=null" class="mb-0 text-center text-md-start text-white fw-bold">
                      {{ last7daysrevenueData.bKashRecurring }} Tk
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                  <div class="modal fade" id="bKashRecurring"  tabindex="-1"  aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                      <div class="modal-content" style="background: #050F1E!important;">
                        <div class="modal-header">
                          <h5 class="modal-title text-white" id="staticBackdropLabel">Last 7 days bKash Recurring revenue</h5>
                          <button type="button" class="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                          <div class="table-responsive">
                            <table class="table caption-top table-success table-striped">
                              <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Revenue</th>
                              </tr>
                              </thead>
                              <tbody v-if="last7daysrevenueData.bKashRecurringSUmmary.length > 0">
                              <tr v-for="(data, index) in last7daysrevenueData.bKashRecurringSUmmary" :key="index">
                                <th scope="row">{{index+1}}</th>
                                <td>{{data.date}}</td>
                                <td>{{ data.amount }}</td>
                              </tr>
                              </tbody>
                              <tbody v-else>
                              <tr>
                                <td align="center" colspan="3">No Data</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success5 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100 cp" data-bs-toggle="modal" data-bs-target="#bkashOnetime">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    bKash Onetime
                  </p>
                  <h5 v-if="last7daysrevenueData.bkashOnetime!=null" class="mb-0 text-center text-md-start text-white fw-bold">
                      {{ last7daysrevenueData.bkashOnetime }} Tk
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                  <div class="modal fade" id="bkashOnetime"  tabindex="-1"  aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                      <div class="modal-content" style="background: #050F1E!important;">
                        <div class="modal-header">
                          <h5 class="modal-title text-white" id="staticBackdropLabel">Last 7 days bKash Onetime revenue</h5>
                          <button type="button" class="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                          <div class="table-responsive">
                            <table class="table caption-top table-success table-striped">
                              <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Revenue</th>
                              </tr>
                              </thead>
                              <tbody v-if="last7daysrevenueData.bkashOnetimeSummary.length > 0">
                              <tr v-for="(data, index) in last7daysrevenueData.bkashOnetimeSummary" :key="index">
                                <th scope="row">{{index+1}}</th>
                                <td>{{ data.date}}</td>
                                <td>{{ data.amount }}</td>
                              </tr>
                              </tbody>
                              <tbody v-else>
                              <tr>
                                <td align="center" colspan="3">No Data</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success5 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100 cp" data-bs-toggle="modal" data-bs-target="#nagadOnetime">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    nagad Onetime
                  </p>
                  <h5 v-if="last7daysrevenueData.nagadOnetime!=null" class="mb-0 text-center text-md-start text-white fw-bold">
                      {{ last7daysrevenueData.nagadOnetime }} Tk
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                  <div class="modal fade" id="nagadOnetime"  tabindex="-1"  aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                      <div class="modal-content" style="background: #050F1E!important;">
                        <div class="modal-header">
                          <h5 class="modal-title text-white" id="staticBackdropLabel">Last 7 days nagad Onetime revenue</h5>
                          <button type="button" class="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                          <div class="table-responsive">
                            <table class="table caption-top table-success table-striped">
                              <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Revenue</th>
                              </tr>
                              </thead>
                              <tbody v-if="last7daysrevenueData.nagadOnetimeSummary.length > 0">
                              <tr v-for="(data, index) in last7daysrevenueData.nagadOnetimeSummary" :key="index">
                                <th scope="row">{{index+1}}</th>
                                <td>{{ data.date}}</td>
                                <td>{{ data.amount }}</td>
                              </tr>
                              </tbody>
                              <tbody v-else>
                              <tr>
                                <td align="center" colspan="3">No Data</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success5 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100 cp" data-bs-toggle="modal" data-bs-target="#resultSurjopayOnetime">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    Surjopay Onetime
                  </p>
                  <h5 v-if="last7daysrevenueData.resultSurjopayOnetime!=null" class="mb-0 text-center text-md-start text-white fw-bold">
                      {{ last7daysrevenueData.resultSurjopayOnetime }} Tk
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                  <div class="modal fade" id="resultSurjopayOnetime"  tabindex="-1"  aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                      <div class="modal-content" style="background: #050F1E!important;">
                        <div class="modal-header">
                          <h5 class="modal-title text-white" id="staticBackdropLabel">Last 7 days Surjopay Onetime revenue</h5>
                          <button type="button" class="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                          <div class="table-responsive">
                            <table class="table caption-top table-success table-striped">
                              <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Revenue</th>
                              </tr>
                              </thead>
                              <tbody v-if="last7daysrevenueData.resultSurjopayOnetimeSummary.length > 0">
                              <tr v-for="(data, index) in last7daysrevenueData.resultSurjopayOnetimeSummary" :key="index">
                                <th scope="row">{{index+1}}</th>
                                <td>{{ data.date}}</td>
                                <td>{{ data.amount }}</td>
                              </tr>
                              </tbody>
                              <tbody v-else>
                              <tr>
                                <td align="center" colspan="3">No Data</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success5 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100 cp" data-bs-toggle="modal" data-bs-target="#resultUpayOnetime">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    Upay Onetime
                  </p>
                  <h5 v-if="last7daysrevenueData.resultUpayOnetime !=null" class="mb-0 text-center text-md-start text-white fw-bold">
                      {{ last7daysrevenueData.resultUpayOnetime }} Tk
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                  <div class="modal fade" id="resultUpayOnetime"  tabindex="-1"  aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                      <div class="modal-content" style="background: #050F1E!important;">
                        <div class="modal-header">
                          <h5 class="modal-title text-white" id="staticBackdropLabel">Last 7 days Upay Onetime revenue</h5>
                          <button type="button" class="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                          <div class="table-responsive">
                            <table class="table caption-top table-success table-striped">
                              <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Revenue</th>
                              </tr>
                              </thead>
                              <tbody v-if="last7daysrevenueData.resultUpayOnetimeSUmmary.length > 0">
                              <tr v-for="(data, index) in last7daysrevenueData.resultUpayOnetimeSUmmary" :key="index">
                                <th scope="row">{{index+1}}</th>
                                <td>{{ data.date}}</td>
                                <td>{{ data.amount }}</td>
                              </tr>
                              </tbody>
                              <tbody v-else>
                              <tr>
                                <td align="center" colspan="3">No Data</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success5 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                   Total
                  </p>
                  <h5 class="mb-0 text-center text-md-start text-white fw-bold">
                      {{ last7daysrevenueData.bKashRecurring + last7daysrevenueData.bkashOnetime + last7daysrevenueData.nagadOnetime + last7daysrevenueData.resultSurjopayOnetime + last7daysrevenueData.resultUpayOnetime}} Tk
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <h4 class="revenue-header2 fw-bolder">Last 30 days revenue</h4>
      <div class="row gy-4 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
        <div class="col stretch-card">
          <div class="card bg-gradient-success4 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100 cp" data-bs-toggle="modal" data-bs-target="#bKashRecurring30">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    bKash Recurring
                  </p>
                  <h5 v-if="last30daysrevenueData.bKashRecurring!=null" class="mb-0 text-center text-md-start text-white fw-bold">
                      {{ last30daysrevenueData.bKashRecurring }} Tk
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                  <div class="modal fade" id="bKashRecurring30"  tabindex="-1"  aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                      <div class="modal-content" style="background: #050F1E!important;">
                        <div class="modal-header">
                          <h5 class="modal-title text-white" id="staticBackdropLabel">Last 30 days bKash Recurring revenue</h5>
                          <button type="button" class="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                          <div class="table-responsive">
                            <table class="table caption-top table-success table-striped">
                              <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Revenue</th>
                              </tr>
                              </thead>
                              <tbody v-if="last30daysrevenueData.bKashRecurringSUmmary.length > 0">
                              <tr v-for="(data, index) in last30daysrevenueData.bKashRecurringSUmmary" :key="index">
                                <th scope="row">{{index+1}}</th>
                                <td>{{ data.date}}</td>
                                <td>{{ data.amount }}</td>
                              </tr>
                              </tbody>
                              <tbody v-else>
                              <tr>
                                <td align="center" colspan="3">No Data</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success4 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100 cp" data-bs-toggle="modal" data-bs-target="#bkashOnetime30">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    bKash Onetime
                  </p>
                  <h5 v-if="last30daysrevenueData.bkashOnetime!=null" class="mb-0 text-center text-md-start text-white fw-bold">
                      {{ last30daysrevenueData.bkashOnetime }} Tk
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                  <div class="modal fade" id="bkashOnetime30"  tabindex="-1"  aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                      <div class="modal-content" style="background: #050F1E!important;">
                        <div class="modal-header">
                          <h5 class="modal-title text-white" id="staticBackdropLabel">Last 30 days bKash Onetime revenue</h5>
                          <button type="button" class="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                          <div class="table-responsive">
                            <table class="table caption-top table-success table-striped">
                              <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Revenue</th>
                              </tr>
                              </thead>
                              <tbody v-if="last30daysrevenueData.bkashOnetimeSummary.length > 0">
                              <tr v-for="(data, index) in last30daysrevenueData.bkashOnetimeSummary" :key="index">
                                <th scope="row">{{index+1}}</th>
                                <td>{{ data.date}}</td>
                                <td>{{ data.amount }}</td>
                              </tr>
                              </tbody>
                              <tbody v-else>
                              <tr>
                                <td align="center" colspan="3">No Data</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success4 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100 cp" data-bs-toggle="modal" data-bs-target="#nagadOnetime30">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    nagad Onetime
                  </p>
                  <h5 v-if="last30daysrevenueData.nagadOnetime!=null" class="mb-0 text-center text-md-start text-white fw-bold">
                      {{ last30daysrevenueData.nagadOnetime }} Tk
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                  <div class="modal fade" id="nagadOnetime30"  tabindex="-1"  aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                      <div class="modal-content" style="background: #050F1E!important;">
                        <div class="modal-header">
                          <h5 class="modal-title text-white" id="staticBackdropLabel">Last 30 days nagad Onetime revenue</h5>
                          <button type="button" class="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                          <div class="table-responsive">
                            <table class="table caption-top table-success table-striped">
                              <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Revenue</th>
                              </tr>
                              </thead>
                              <tbody v-if="last30daysrevenueData.nagadOnetimeSummary.length > 0">
                              <tr v-for="(data, index) in last30daysrevenueData.nagadOnetimeSummary" :key="index">
                                <th scope="row">{{index+1}}</th>
                                <td>{{ data.date}}</td>
                                <td>{{ data.amount }}</td>
                              </tr>
                              </tbody>
                              <tbody v-else>
                              <tr>
                                <td align="center" colspan="3">No Data</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success4 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100 cp" data-bs-toggle="modal" data-bs-target="#resultSurjopayOnetime30">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    Surjopay Onetime
                  </p>
                  <h5 v-if="last30daysrevenueData.resultSurjopayOnetime!=null" class="mb-0 text-center text-md-start text-white fw-bold">
                      {{ last30daysrevenueData.resultSurjopayOnetime }} Tk
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                  <div class="modal fade" id="resultSurjopayOnetime30"  tabindex="-1"  aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                      <div class="modal-content" style="background: #050F1E!important;">
                        <div class="modal-header">
                          <h5 class="modal-title text-white" id="staticBackdropLabel">Last 30 days Surjopay Onetime revenue</h5>
                          <button type="button" class="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                          <div class="table-responsive">
                            <table class="table caption-top table-success table-striped">
                              <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Revenue</th>
                              </tr>
                              </thead>
                              <tbody v-if="last30daysrevenueData.resultSurjopayOnetimeSummary.length > 0">
                              <tr v-for="(data, index) in last30daysrevenueData.resultSurjopayOnetimeSummary" :key="index">
                                <th scope="row">{{index+1}}</th>
                                <td>{{ data.date}}</td>
                                <td>{{ data.amount }}</td>
                              </tr>
                              </tbody>
                              <tbody v-else>
                              <tr>
                                <td align="center" colspan="3">No Data</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success4 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100 cp" data-bs-toggle="modal" data-bs-target="#resultUpayOnetime30">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    Upay Onetime
                  </p>
                  <h5 v-if="last30daysrevenueData.resultUpayOnetime !=null" class="mb-0 text-center text-md-start text-white fw-bold">
                      {{ last30daysrevenueData.resultUpayOnetime }} Tk
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                  <div class="modal fade" id="resultUpayOnetime30"  tabindex="-1"  aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                      <div class="modal-content" style="background: #050F1E!important;">
                        <div class="modal-header">
                          <h5 class="modal-title text-white" id="staticBackdropLabel">Last 30 days Upay Onetime revenue</h5>
                          <button type="button" class="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                          <div class="table-responsive">
                            <table class="table caption-top table-success table-striped">
                              <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Revenue</th>
                              </tr>
                              </thead>
                              <tbody v-if="last30daysrevenueData.resultUpayOnetimeSUmmary.length > 0">
                              <tr v-for="(data, index) in last30daysrevenueData.resultUpayOnetimeSUmmary" :key="index">
                                <th scope="row">{{index+1}}</th>
                                <td>{{ data.date}}</td>
                                <td>{{ data.amount }}</td>
                              </tr>
                              </tbody>
                              <tbody v-else>
                              <tr>
                                <td align="center" colspan="3">No Data</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success4 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                   Total
                  </p>
                  <h5 class="mb-0 text-center text-md-start text-white fw-bold">
                      {{ last30daysrevenueData.bKashRecurring + last30daysrevenueData.bkashOnetime + last30daysrevenueData.nagadOnetime + last30daysrevenueData.resultSurjopayOnetime + last30daysrevenueData.resultUpayOnetime}} Tk
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--revenue -->

    <!--Subscription  -->
    <div class="mb-3">
      <h4 class="subscription-header fw-bolder">Subscription</h4>
      <div class="row gy-4 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
        <div class="col stretch-card">
          <div class="card bg-gradient-warning h-100">
            <div class="card-body h-100">
              <div class="h-100 d-flex flex-column flex-md-row align-items-center justify-content-center">
                <YesterdayTotalPurchaseAmount></YesterdayTotalPurchaseAmount>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-warning h-100">
            <div class="card-body h-100">
              <div class="h-100 d-flex flex-column flex-md-row align-items-center justify-content-center">
                <TodaySubscriptionCount></TodaySubscriptionCount>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-warning h-100">
            <div class="card-body h-100">
              <div class="h-100 d-flex flex-column flex-md-row align-items-center justify-content-center">
                <TodayUnsubscriptionCount></TodayUnsubscriptionCount>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card ">
          <div class="card bg-gradient-warning h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <TodayTotalSignup></TodayTotalSignup>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-warning h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center">
                <YesterdayTotalSignup></YesterdayTotalSignup>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--Subscription  -->

      <!--Life Time Subscriber  -->
    <div class="mb-3">
      <h4 class="LifeTimeSubscriber-header fw-bolder">Life Time Subscriber</h4>
      <div class="row gy-4 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
        <div class="col stretch-card">
          <div class="card bg-gradient-success6 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    bKash Recurring
                  </p>
                  <h5 v-if="allPGWSubscriberCountData.bKashRecurring!=null" class="mb-0 text-center text-md-start text-white fw-bold">
                    {{ allPGWSubscriberCountData.bKashRecurring }}
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success6 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    bKash Onetime
                  </p>
                  <h5 v-if="allPGWSubscriberCountData.bkashOnetime!=null" class="mb-0 text-center text-md-start text-white fw-bold">
                    {{ allPGWSubscriberCountData.bkashOnetime }}
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success6 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    nagad Onetime
                  </p>
                  <h5 v-if="allPGWSubscriberCountData.nagadOnetime!=null" class="mb-0 text-center text-md-start text-white fw-bold">
                    {{ allPGWSubscriberCountData.nagadOnetime }}
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success6 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    Surjopay Onetime
                  </p>
                  <h5 v-if="allPGWSubscriberCountData.resultSurjopayOnetime!=null" class="mb-0 text-center text-md-start text-white fw-bold">
                    {{ allPGWSubscriberCountData.resultSurjopayOnetime }}
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success6 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    Upay Onetime
                  </p>
                  <h5 v-if="allPGWSubscriberCountData.resultUpayOnetime!=null" class="mb-0 text-center text-md-start text-white fw-bold">
                    {{ allPGWSubscriberCountData.resultUpayOnetime }}
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success6 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    Upay Onetime
                  </p>
                  <h5 v-if="allPGWSubscriberCountData.resultUpayOnetime!=null" class="mb-0 text-center text-md-start text-white fw-bold">
                    {{ allPGWSubscriberCountData.resultUpayOnetime }}
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success6 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    total
                  </p>
                  <h5 class="mb-0 text-center text-md-start text-white fw-bold">
                    {{ allPGWSubscriberCountData.bKashRecurring + allPGWSubscriberCountData.bkashOnetime + allPGWSubscriberCountData.nagadOnetime + allPGWSubscriberCountData.resultSurjopayOnetime + allPGWSubscriberCountData.resultUpayOnetime }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success6 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                    Cancelled BKash Recurring
                  </p>
                  <h5 v-if="allPGWSubscriberCountData.cancelledBKashRecurring!=null" class="mb-0 text-center text-md-start text-white fw-bold">
                    {{ allPGWSubscriberCountData.cancelledBKashRecurring }}
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
 <!--Life Time Subscriber  -->

 <!--Package wise Active subscribers -->
    <div class="mb-3">
      <h4 class="Packagesubscription-header fw-bolder">Package wise Active subscribers</h4>
      <div class="row gy-4 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
        <div class="col stretch-card" v-for="(data,index) in allPGWSubscriberCountData.packagewisePresentSubscription" :key="index">
          <div class="card bg-gradient-success7 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <div class="w-100">
                  <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
                   {{data.name}}
                  </p>
                  <h5 v-if="data.total!=null" class="mb-0 text-center text-md-start text-white fw-bold">
                    {{ data.total }}
                  </h5>
                  <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                    0
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--Package wise Active subscribers  -->

    <!--Playcount  -->
    <div class="mb-3">
      <h3 class="PlayCount-header">Play Count</h3>
      <div class="row gy-4 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
        <div class="col stretch-card">
          <div class="card bg-gradient-success2 h-100">
            <div class="card-body h-100">
              <div class="h-100 d-flex flex-column flex-md-row align-items-center justify-content-center">
                <TodayTotalPlayCount></TodayTotalPlayCount>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success2 h-100">
            <div class="card-body h-100">
              <div class="h-100 d-flex flex-column flex-md-row justify-content-center align-items-center">
                <YesterdayTotalPlayCount></YesterdayTotalPlayCount>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success2 h-100">
            <div class="card-body h-100">
              <div class="d-flex flex-column flex-md-row align-items-center justify-content-center h-100">
                <TodayTotalPlayCountAudioBook></TodayTotalPlayCountAudioBook>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card">
          <div class="card bg-gradient-success2 h-100">
            <div class="card-body h-100">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center h-100">
                <YesterdayPlayCountAudioBook></YesterdayPlayCountAudioBook>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card ">
          <div class="card bg-gradient-success2 h-100">
            <div class="card-body h-100">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center">
                <EpisodeTotalPlayCount></EpisodeTotalPlayCount>
              </div>
            </div>
          </div>
        </div>
        <div class="col stretch-card ">
          <div class="card bg-gradient-success2 h-100">
            <div class="card-body h-100" style="">
              <div class="d-flex flex-column flex-md-row justify-content-center align-items-center">
                <YesterdayEpisodePlayCount></YesterdayEpisodePlayCount>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--Playcount  -->

    <!--div class="row gy-4 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5">
      <div class="col ">
        <div class="card bg-gradient-warning ">

          <div class="card-body" style="">
            <div class="d-flex flex-column flex-md-row">

              <div class="ps-0 ps-md-2 ps-lg-3">
                <p class="m-0 text-center text-md-start text-white">
                  Total Purchase
                </p>
                <h5 class="mb-0 text-center text-md-start text-white fw-bold">
                  {{ total }}
                </h5>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="col stretch-card ">
        <div class="card bg-gradient-info">
          <div class="card-body" style="">
            <div class="d-flex flex-column flex-md-row">
              <div class="ps-0 ps-md-2 ps-lg-3" style="">
                <p class="m-0 text-center text-md-start text-white">
                  Total purchase datewise
                </p>
                <h5 v-if="datewisePurchase !== null" class="mb-0 text-center text-md-start text-white fw-bold">
                  {{ datewisePurchase }}
                </h5>
                <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
                  0
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col stretch-card ">
        <div class="card bg-gradient-success1">
          <div class="card-body" style="">
            <div class="d-flex flex-column flex-md-row">

              <TodayTotalPlayCount></TodayTotalPlayCount>
            </div>
          </div>
        </div>
      </div>
      <div class="col stretch-card ">
        <div class="card bg-gradient-success2">
          <div class="card-body" style="">
            <div class="d-flex flex-column flex-md-row">
              <YesterdayTotalPlayCount></YesterdayTotalPlayCount>
            </div>
          </div>
        </div>
      </div>
      <div class="col stretch-card ">
        <div class="card bg-gradient-success3">
          <div class="card-body" style="">
            <div class="d-flex flex-column flex-md-row">
              <TodayTotalPlayCountAudioBook></TodayTotalPlayCountAudioBook>
            </div>
          </div>
        </div>
      </div>
      <div class="col stretch-card ">
        <div class="card bg-gradient-success4">
          <div class="card-body" style="">
            <div class="d-flex flex-column flex-md-row">
              <YesterdayPlayCountAudioBook></YesterdayPlayCountAudioBook>
            </div>
          </div>
        </div>
      </div>
      <div class="col stretch-card ">
        <div class="card bg-gradient-success5">
          <div class="card-body" style="">
            <div class="d-flex flex-column flex-md-row">
              <EpisodeTotalPlayCount></EpisodeTotalPlayCount>
            </div>
          </div>
        </div>
      </div>
      <div class="col stretch-card ">
        <div class="card bg-gradient-success6">
          <div class="card-body" style="">
            <div class="d-flex flex-column flex-md-row">
              <YesterdayEpisodePlayCount></YesterdayEpisodePlayCount>
            </div>
          </div>
        </div>
      </div>
      <div class="col stretch-card ">
        <div class="card bg-gradient-success8">
          <div class="card-body" style="">
            <div class="d-flex flex-column flex-md-row">
              <YesterdayTotalPurchaseAmount></YesterdayTotalPurchaseAmount>
            </div>
          </div>
        </div>
      </div>
      <div class="col stretch-card ">
        <div class="card bg-gradient-success9">
          <div class="card-body" style="">
            <div class="d-flex flex-column flex-md-row">
              <TodayTotalSignup></TodayTotalSignup>
            </div>
          </div>
        </div>
      </div>
      <div class="col stretch-card  co">
        <div class="card bg-gradient-success">
          <div class="card-body" style="">
            <div class="d-flex flex-column flex-md-row">
              <YesterdayTotalSignup></YesterdayTotalSignup>
            </div>
          </div>
        </div>
      </div>
    </div-->

  </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import TodayTotalPlayCount from '../pages/dashboard/TodayTotalPlayCount'
import YesterdayTotalPlayCount from '../pages/dashboard/YesterdayTotalPlayCount'
import TodayTotalPlayCountAudioBook from '../pages/dashboard/TodayTotalPlayCountAudioBook'
import YesterdayPlayCountAudioBook from '../pages/dashboard/YesterdayPlayCountAudioBook'
import EpisodeTotalPlayCount from '../pages/dashboard/EpisodeTotalPlayCount'
import YesterdayEpisodePlayCount from '../pages/dashboard/YesterdayEpisodePlayCount'
//import TodayTotalPurchaseAmount from '../pages/dashboard/TodayTotalPurchaseAmount'
import YesterdayTotalPurchaseAmount from '../pages/dashboard/YesterdayTotalPurchaseAmount'
import TodayTotalSignup from '../pages/dashboard/TodayTotalSignup'
import YesterdayTotalSignup from '../pages/dashboard/YesterdayTotalSignup'
import TodaySubscriptionCount from "@/pages/dashboard/TodaySubscriptionCount";
import TodayUnsubscriptionCount from "@/pages/dashboard/TodayUnsubscriptionCount";
export default {
  name: "home",
  components: {
    Loading, TodayTotalPlayCount, YesterdayTotalPlayCount,
    TodayTotalPlayCountAudioBook, YesterdayPlayCountAudioBook,
    EpisodeTotalPlayCount, YesterdayEpisodePlayCount,
    YesterdayTotalPurchaseAmount, TodayTotalSignup, YesterdayTotalSignup,
    TodaySubscriptionCount, TodayUnsubscriptionCount
  },
  props: ["publisherCount"],
  data() {
    return {
      Homedata: {
        episodeCount: 0,
        audiobookCount: 0,
        playCount: 0,
      },
      id: localStorage.getItem(this.$idKey),
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars",
      datewisePurchase: "",
      total: "",
      last7daysrevenueData: undefined,
      last30daysrevenueData: undefined,
      allPGWSubscriberCountData: undefined
    };
  },
  mounted() {
    this.getAdminPublisherId();
    this.totalPurchaseDateWise()
    this.totalList();
    this.getLast7daysrevenue()
    this.getLast30daysrevenue()
    this.allPGWSubscriberCount()
  },
  methods: {
    async totalPurchaseDateWise() {
      const token = localStorage.getItem(this.$tokenKey);
      try {
        this.isLoading = true
        const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/kabbikanalytics/total-purchase-date-wise", {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          }
        }
        );
        if (res.status == 200) {
          // console.log(res)
          this.datewisePurchase = res.data[0].total_purchase_amount
          this.isLoading = false;
          // console.log(this.datewisePurchase)
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },

    async totalList() {
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/kabbikanalytics/total-purchase",
          {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          }
        }
        );
        if (res.status == 200) {
          // console.log(res)
          this.total = res.data[0].total_purchase_amount
          console.log(this.total)
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },

    async getLast7daysrevenue() {
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
            this.$baseUrl +
            this.$api +
            this.$version1 +
            "/kabbikanalytics/revenueSummaryPGW",
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              }
            }
        );
        if (res.status === 200) {
          console.log(res)
          this.last7daysrevenueData = res.data.data
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async getLast30daysrevenue() {
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
            this.$baseUrl +
            this.$api +
            this.$version1 +
            "/kabbikanalytics/revenueSummaryPGW30Days",
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              }
            }
        );
        if (res.status === 200) {
          console.log(res)
          this.last30daysrevenueData = res.data.data
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async allPGWSubscriberCount() {
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
            this.$baseUrl +
            this.$api +
            this.$version1 +
            "/kabbikanalytics/allPGWSubscriberCount",
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              }
            }
        );
        if (res.status === 200) {
          console.log(res)
          this.allPGWSubscriberCountData = res.data.data
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async getAdminPublisherId() {
      const token = localStorage.getItem(this.$tokenKey);
      try {
        this.isLoading = true;
        const res = await axios.get(
          this.$baseUrl +
          this.$api +
          this.$version1 +
          "/publishers/getAdminPublishserId/" +
          this.id,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        console.log(res);
        if (res.status == 200) {
          // console.log(res.data);
          localStorage.setItem(this.$publisherId, res.data.id);
          this.isLoading = false;
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
  },


};
</script>

<style scoped >
@import "../assets/css/home.scss";
.revenue-header1{
  background: linear-gradient(to right, rgb(204 80 198 / 70%), rgb(245 0 131 / 90%));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}.revenue-header2{
  background: linear-gradient(to right, rgb(132 80 204 / 70%), rgb(164 0 245 / 90%));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.subscription-header{
  background: linear-gradient(to right, rgba(255, 88, 88, 0.9), rgba(240, 152, 25, 0.9));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.Packagesubscription-header{
  background: linear-gradient(to right, rgb(204 123 80 / 70%), rgb(245 106 0 / 90%));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.LifeTimeSubscriber-header{
  background: linear-gradient(to right, rgb(80 200 204 / 70%), rgb(102 0 245 / 90%));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.PlayCount-header{
  font-weight: bolder;
  background: linear-gradient(to right, rgb(80 80 204 / 70%), rgb(0 42 245 / 90%));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.bg-gradient-warning {
  background: linear-gradient(to right, rgba(255, 88, 88, 0.9), rgba(240, 152, 25, 0.9));
}

.bg-gradient-info {
  background: linear-gradient(to right, rgba(68, 129, 235, 0.9), rgba(4, 190, 254, 0.9));
  color: white;
}

.bg-gradient-success {
  background: linear-gradient(to right, rgba(80, 204, 127, 0.9), rgba(0, 86, 245, 0.9));
  color: white;
}

.bg-gradient-success1 {
  background: linear-gradient(to right, rgb(158 80 204 / 70%), rgb(15 0 245 / 90%));
}

.bg-gradient-success2 {
  background: linear-gradient(to right, rgb(80 80 204 / 70%), rgb(0 42 245 / 90%));
}

.bg-gradient-success3 {
  background: linear-gradient(to right, rgb(80 184 204 / 70%), rgb(0 155 245 / 90%));
}

.bg-gradient-success4 {
  background: linear-gradient(to right, rgb(132 80 204 / 70%), rgb(164 0 245 / 90%));
}

.bg-gradient-success5 {
  background: linear-gradient(to right, rgb(204 80 198 / 70%), rgb(245 0 131 / 90%));
}

.bg-gradient-success6 {
  background: linear-gradient(to right, rgb(80 200 204 / 70%), rgb(102 0 245 / 90%));
}

.bg-gradient-success7 {
  background: linear-gradient(to right, rgb(204 123 80 / 70%), rgb(245 106 0 / 90%));
}

.bg-gradient-success8 {
  background: linear-gradient(to right, rgb(90 80 204 / 70%), rgb(0 155 245 / 90%));
}

.bg-gradient-success9 {
  background: linear-gradient(to right, rgb(116 80 204 / 70%), rgb(0 196 245 / 90%));
}

.bg-gradient-success10 {
  background: linear-gradient(to right, rgb(204 80 136 / 70%), rgb(245 0 49 / 83%));
}

.card {
  border-radius: 18px;
  border: 0px;
  /* box-shadow: rgba(0, 0, 0, 0.2) 0px 60px 40px -7px; */
}

.card-body {

}

.col-md-2 {
  margin-bottom: 23px;
}


/* h5{
  padding-top: 37px;
} */
</style>
